import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import CreativeNameManager from "../../components/CreativeNameGenerator/CreativeNameManager";
import GeneratedNamesList from "../../components/CreativeNameGenerator/GeneratedNamesList";
import { ROUTES } from "../../actions/app/constants";
import { setActiveRoute } from "../../actions/app/navigation";

import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid } from "@material-ui/core";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/name");

const useStyles = makeStyles((theme) => ({
  route: {
    marginTop: theme.spacing(6),
    position: "relative",
    minHeight: "84vh"
  }
}));

const NameGenerator = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveRoute(ROUTES.NAMING_GENERATOR));
  }, [dispatch]);

  return (
    <Container maxWidth="xl" className={classes.route}>
      <Grid container spacing={3}>
        <Grid item xs={5}>
          <GeneratedNamesList />
        </Grid>
        <Grid item xs={7}>
          <CreativeNameManager standalone={true} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default NameGenerator;
